import { EventInfo } from '../types';
import { useForm, SubmitHandler } from "react-hook-form"
import axios from 'axios';
import MDEditor from '@uiw/react-md-editor';
import { useState } from 'react';
import DOMPurify from 'dompurify';
import { Button, Container, Field, Grid, GridItem, Input } from '@chakra-ui/react';
import StyledDropzoneComponent from './style-dropzone-component';
import { api_url } from '@/variables';

const EventsEditorComponent = () => {

    console.log("Loaded events editor")
  
    const [markdown, setMarkdown] = useState("");
    const [image, setImage] = useState<File>()
    const [fileRejectionReason, setFileRejectionReason] = useState("")

    const addEvent = (ev: EventInfo) => {
        ev.long_description = DOMPurify.sanitize(markdown)

        const eventWithoutImage: any = ev
        delete eventWithoutImage.image
        
        axios.post(`${api_url}/events`, eventWithoutImage)
        .then(function (response) {
            // upload the image separately, in case we don't have one
            axios.post(`${api_url}/events/${response.data.event_id}/image`, {file: image}, {
                headers: {
                  'Content-Type': 'multipart/form-data'
                }
              })
        })
        .catch((error) => {
            console.log(error)
        })


    }

    const {
        register,
        handleSubmit,
    } = useForm<EventInfo>()
    const onSubmit: SubmitHandler<EventInfo> = (data) => {
        data.event_id = ""
        addEvent(data)
    }

    const handleFileAccepted = (files: File[]) => {
        console.log("files accepted")
        console.log(files)
        setImage(files[0])
        setFileRejectionReason("")
    } 

    const handleFileRejected = (reason: string) => {
        setFileRejectionReason(reason)
    }


    return (
        <>
        <Container>
            <form onSubmit={handleSubmit(onSubmit)}>
                <Grid>
                    <GridItem colSpan={3}>
                        <Field.Root>
                            <Field.Label >Title</Field.Label>
                            <Input type="text" className="form-control" id="name-input" {...register("name")} />
                        </Field.Root>
                    </GridItem>
                    <GridItem>
                        <Field.Root>
                            <Field.Label >Date</Field.Label>
                            <Input type="date" id="form-date" {...register("date")} />
                        </Field.Root>
                    </GridItem>
                    <GridItem>
                        <Field.Root>
                            <Field.Label >Start time (CST)</Field.Label>
                            <Input type="time" id="form-start-time" {...register("start_time")} />
                        </Field.Root>
                    </GridItem>
                    <GridItem>
                        <Field.Root>
                            <Field.Label >End time (CST)</Field.Label>
                            <Input type="time" id="form-end-time" {...register("end_time")} />
                        </Field.Root>
                    </GridItem>
                    <GridItem colSpan={3}>
                        <Field.Root>
                            <Field.Label >Address</Field.Label>
                            <Input type="text" className="form-control" id="form-address" {...register("location")} />
                        </Field.Root>
                    </GridItem>
                    <GridItem colSpan={3} rowSpan={3}>
                        <Field.Root>
                            <Field.Label >Description</Field.Label>
                            <Input className="form-control" id="form-description" {...register("short_description")} />
                        </Field.Root>
                    </GridItem>
                    <GridItem colSpan={3} rowSpan={4}>
                        <Field.Root>
                            <Field.Label >Long description</Field.Label>
                            <div data-color-mode="light">
                                <MDEditor value={markdown} onChange={(val) =>
                                setMarkdown(val || "")} />
                            </div>
                        </Field.Root>
                    </GridItem>
                    <GridItem colSpan={3}>
                        <Field.Root>
                            <Input type="checkbox" id="form-need-supplies" {...register("need_supplies")} /> 
                            &nbsp;&nbsp;Do you want attendees to bring food and other supplies to this event?
                        </Field.Root>
                    </GridItem>
                    <GridItem colSpan={3}>
                        <Field.Root>
                            <Field.Label >Header image</Field.Label>
                            <br/>
                            <StyledDropzoneComponent onFileAccepted={handleFileAccepted} onFileRejected={handleFileRejected} maxFiles={1}>
                                <p>Drag an image here, or click to select an image.</p>
                            </StyledDropzoneComponent>
                            {fileRejectionReason.length > 0 && 
                            <span style={{color: "red"}}><strong>{fileRejectionReason}</strong></span>
                            }
                            { image &&
                            <span style={{color: "green"}}><strong>Selected {image.name}</strong></span>
                            }
                        </Field.Root>
                    </GridItem>
                    <GridItem colSpan={3}>
                        <Field.Root>
                            <Button
                                _hover={{borderColor: "grackle.400", borderWidth:"2px"}}
                                _focus={{bg: "grackle.100"}}
                                bg="grackle.800"  
                                color="whiteAlpha.900" 
                                type='submit'
                            >
                                Submit
                            </Button>
                        </Field.Root>
                    </GridItem>
                </Grid>
            </form>
        </Container>
        </>

    )
}

export default EventsEditorComponent
